import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ChangePassword from "./pages/ChangePassword";
import Settings from "./pages/Settings";
import StaffManagement from "./pages/StaffManagement";
import ManageSubjects from "./pages/ManageSubjects";
import StaffSubjects from "./pages/StaffSubjects";
import StaffPermission from "./pages/StaffPermission";
import AccountsManagement from "./pages/AccountsManagement";
import BatchManagement from "./pages/BatchManagement";
import LabelManagement from "./pages/LabelManagement";
import StudentList from "./pages/StudentList";
import StudentView from "./pages/StudentView";
import StudentEdit from "./pages/StudentEdit";
import StudentCreate from "./pages/StudentCreate";
import BatchSelection from "./pages/BatchSelection";
import StudentAttendance from "./pages/StudentAttendance";
import MonthlyAttendancePage from "./pages/GetMonthlyAttendance";
import SwipeCard from "./pages/SwipeCard";
import Receipt from "./pages/Receipt";
import AccountStatement from "./pages/AccountStatement";
import ReceiptList from "./pages/ReceiptList";
import EditReceipt from "./pages/EditReceipt";
import Payment from "./pages/Payment";
import PaymentList from "./pages/PaymentList";
import EditPayment from "./pages/EditPayment";
import Contra from "./pages/Contra";
import ContraList from "./pages/ContraList";
import EditContra from "./pages/EditContra";
import Journal from "./pages/Journal";
import JournalList from "./pages/JournalList";
import EditJournal from "./pages/EditJournal";
import AccountTypeSummary from "./pages/AccountTypeSummary";
import StudentNotes from "./pages/StudentNotes";
import StudentSummary from "./pages/StudentSummary";
import FeeManagement from "./pages/FeeManagement";
import ListTransactions from "./pages/ListTransactions";
import ExamManagement from "./pages/ExamManagement";
import ExamMarkEntry from "./pages/ExamMarkEntry";
import TestsPage from "./pages/TestsPage";
import TestMarksEntryPage from "./pages/TestMarksEntryPage";
import StudentFeeSummary from "./pages/StudentFeeSummary";
import TestMarksReport from "./pages/TestMarksReport";
import CompareMarksPage from "./pages/CompareTestMarks";
import TermExamsPage from "./pages/TermExamsPage";
import MarkEntryPage from "./pages/MarkEntryPage";
import BulkUploadStudents from "./pages/BulkUploadStudents";
import StudentSummaryPrintable from "./pages/StudentSummaryPrintable";
import TermExamMarksView from "./pages/TermExamMarksView";

const App = () => {
  return (
    <Router basename="/inst"> {/* ✅ Added basename="/inst" */}
      <AppProvider>
        <Routes>
          {/* Redirect base /inst/ to /inst/login */}
          <Route path="/" element={<Navigate to="/login" />} />

          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes (Require Authentication) */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/staff-management" element={<StaffManagement />} />
          <Route path="/manage-subjects" element={<ManageSubjects />} />
          <Route path="/staff-subjects/:staffId" element={<StaffSubjects />} />
          <Route path="/staff-permission/:staffId" element={<StaffPermission />} />
          <Route path="/account-management" element={<AccountsManagement />} />
          <Route path="/batch-management" element={<BatchManagement />} />
          <Route path="/label-management" element={<LabelManagement />} />
          <Route path="/student-list" element={<StudentList />} />
          <Route path="/student-view/:id" element={<StudentView />} />
          <Route path="/edit-student/:id" element={<StudentEdit />} />
          <Route path="/create-student" element={<StudentCreate />} />
          <Route path="/attendance-management" element={<BatchSelection />} />
          <Route path="/attendance/:batchId" element={<StudentAttendance />} />
          <Route path="/get-monthly-attendance" element={<MonthlyAttendancePage />} />
          <Route path="/swipe-card" element={<SwipeCard />} />
          <Route path="/receipt" element={<Receipt />} />
          <Route path="/account-statement" element={<AccountStatement />} />
          <Route path="/receipt-list" element={<ReceiptList />} />
          <Route path="/edit-receipt/:id" element={<EditReceipt />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment-list" element={<PaymentList />} />
          <Route path="/edit-payment/:id" element={<EditPayment />} />
          <Route path="/contra" element={<Contra />} />
          <Route path="/contra-list" element={<ContraList />} />
          <Route path="/edit-contra/:id" element={<EditContra />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal-list" element={<JournalList />} />
          <Route path="/edit-journal/:id" element={<EditJournal />} />
          <Route path="/acc-type-summary" element={<AccountTypeSummary />} />
          <Route path="/student-summary/:studentId" element={<StudentSummary />} />
          <Route path="/fee-management/:student_id" element={<FeeManagement />} />
          <Route path="/exam-management" element={<ExamManagement />} />
          <Route path="/exam-mark-entry/:examId" element={<ExamMarkEntry />} />
          <Route path="/tests" element={<TestsPage />} />
          <Route path="/test-mark-entry/:testId" element={<TestMarksEntryPage />} />
          <Route path="/fee-summary" element={<StudentFeeSummary />} />
          <Route path="/test-marks-report/:testId" element={<TestMarksReport />} />
          <Route path="/compare-marks" element={<CompareMarksPage />} />
          <Route path="/term-exams" element={<TermExamsPage />} />
          <Route path="/exam-mark-entry" element={<MarkEntryPage />} />
          <Route path="/bulk-upload-students" element={<BulkUploadStudents />} />
          <Route path="/student-summary-printable/:id" element={<StudentSummaryPrintable />} />
          <Route path="/term-exam-marks-view" element={<TermExamMarksView />} />



          <Route path="/list-trans" element={<ListTransactions />} />
        </Routes>
      </AppProvider>
    </Router>
  );
};

export default App;
